import { AxiosError, AxiosResponse } from "axios";
import api from "../axios";
import { ApplySmartHomesReq, ConfirmPaymentRequest, ConfirmPaymentRes } from "../types/samertHomes";
import { GeneralOperationResult } from "../types/GeneralResponse";

export const applySmartHomes = (request: ApplySmartHomesReq, token: string) => {
  const willApply: Promise<any> = new Promise((resolve) => {
    api
      .post("/api/SmartHome/Apply", request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve({ data: response.data });
      })
      .catch((err: AxiosError | any) => {
        resolve({ error: err });
      });
  });

  return willApply;
};

export const confirmSmartHomePayment = (
  request: ConfirmPaymentRequest,
  token: string
) => {
  const willConfirm: Promise<GeneralOperationResult<ConfirmPaymentRes>> =
    new Promise((resolve) => {
      api
        .post("/api/SmartHome/ConfirmPayment", request, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response: AxiosResponse<ConfirmPaymentRes>) => {
          resolve({ data: response.data });
        })
        .catch((err: AxiosError | any) => {
          resolve({ error: err });
        });
    });

  return willConfirm;
};
